export const CLEAR_LOCATION_SUGGEST_LIST = 'CLEAR_LOCATION_SUGGEST_LIST'

export interface ClearLocationSuggestListAction {
  type: typeof CLEAR_LOCATION_SUGGEST_LIST
}

export const clearLocationSuggestListAction = () => ({
  type: CLEAR_LOCATION_SUGGEST_LIST,
})
